<template>
  <div class="">
    <div class="s-layout__index_header">
     
      <div class="btn-group">
        <button
          type="button"
          @click="$router.push({ name: 'cashier-payments-index' })"
          class="btn"
          :class="$route.name == 'cashier-payments-index' ? 'active' : ''"
        >
          <i class="bi bi-currency-bitcoin"></i>

          Paiements
        </button>

        <button
          type="button"
          @click="$router.push({ name: 'cashier-payments-tovalidate-index' })"
          class="btn"
          :class="$route.name == 'cashier-payments-tovalidate-index' ? 'active' : ''"
        >
          <i class="bi bi-chat-left-dots-fill"></i>

          À Valider
        </button>

        <button
          type="button"
          @click="$router.push({ name: 'cashier-payments-noticed-index' })"
          class="btn"
          :class="$route.name == 'cashier-payments-noticed-index' ? 'active' : ''"
        >
          <i class="bi bi-chat-left-dots-fill"></i>

          Remarqué
        </button>
      </div>
    </div>

    <br />
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    window.location;
  },
};
</script>
